<script lang="ts">
    import {t} from 'i18n-js';
    import financing from '../../financing';
    import { formatSentence } from '../../i18n';

    const SCOPE = {scope: 'Financing.Table'};

    export let MONTHS: Array<number> = [];

    export let price: number | undefined = undefined;
</script>

<h3>{t('heading', SCOPE)}</h3>

<p>
    {t('text.cta', SCOPE)}<br>
    {t('text.duration', {months: formatSentence(MONTHS, ", ", " oder "), ...SCOPE})}<br>
    {t('text.details', SCOPE)}
</p>

{#await import('../../yoocon-shop') then}
{#if price}
<table>
    <thead>
        <tr>
            <th>{t('duration', SCOPE)}</th>
            <th>{t('monthly_rate', SCOPE)}</th>
        </tr>
    </thead>
    <tbody>
    {#each MONTHS as months}
        {@const plan = financing(price, {months})}
        <tr>
            <td>{t('months', {count: months, ...SCOPE})}</td>
            <td>{plan?.monthlyText}</td>
        </tr>
    {/each}
    </tbody>
</table>
{/if}
{/await}
